export default "__VITE_ASSET__21xQbYw1__ 100w";